<template>
  <div>
    <v-row justify="center" class="px-2 ">
      <v-col sm="12" md="6" lg="6">
        <v-dialog v-model="showImpersonationDialog" max-width="500px" height="auto" persistent>
          <v-card class="add-menu containerbox" style="overflow-x: hidden;">
            <v-card-title class="text-subtitle-1  text-wrap text-break">User Impersonation List</v-card-title>
            <v-divider></v-divider>
            <template>
              <v-row class="px-5 py-0 pt-3 pb-3">
                <v-col cols="12" sm="12" md="12" lg="12">
                  <v-select v-model="selectedUser" :items="userList" item-text="name" item-value="userId"
                    label="Select User to Impersonate" color="primarytext" outlined dense persistent-placeholder
                    @change="onUserChange">
                    <template v-slot:selection="{ item }">
                      {{ item.name }} ({{ item.email }})
                    </template>
                    <template v-slot:item="{ item }">
                      <v-list-item-content >
                        <v-list-item-title>{{ item.name }}</v-list-item-title>
                        <v-list-item-subtitle class="text-caption text-grey">
                          {{ item.email }}
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </template>
                  </v-select>
                </v-col>
              </v-row>
              <v-alert v-if="selectedUser" type="warning" dense text>
                You are going to impersonate {{ getCurrentUserName }} ({{ getCurrentUserEmail }})
              </v-alert>
              <v-card-actions>

                <v-spacer></v-spacer>
                <template>
                  <v-btn color="primarytext" outlined dense class="ma-2 btn-style" elevation="1" @click="onClickOk">{{
                    this.buttonSubmitText || "OK" }}</v-btn>
                  <v-btn color="secondary" outlined dense class="ma-2 btn-style" elevation="1" @click="onClickCancel">{{
                    this.buttonCancelText || "Cancel" }}
                  </v-btn>
                </template>
                <v-spacer></v-spacer>
              </v-card-actions>
            </template>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import encryptUtility from '../utility/js/encrypt-utility'
import { bus } from "../../main";
import commonApiService from './js/common-api-service';

export default {
  name: 'UserImitationSwitch',

  props: {
    showImpersonationDialog: {
      type: Boolean,
      required: true
    },
    buttonSubmitText: {
      type: String,
      default: 'OK'
    },
    buttonCancelText: {
      type: String,
      default: 'Cancel'
    }
  },

  data() {
    return {
      enabled: false,
      selectedUser: null,
      userList: [],
      userId: encryptUtility.localStorageDecrypt("userID"),
      isLoading: false,
      error: null,
      impId: null,
    }
  },

  computed: {
    currentUser() {
      const user = this.userList.find(u => u.userId === this.selectedUser);
      return {
        name: user?.name || '',
        email: user?.email || '',
        userId: user?.userId || ''
      }

    },
    getCurrentUserName() {
      const user = this.userList.find(u => u.userId === this.selectedUser)
      return user ? user.name : ''
    },
    getCurrentUserEmail() {
      const user = this.userList.find(u => u.userId === this.selectedUser)
      return user ? user.email : ''
    },
    isValid() {
      return this.selectedUser && !this.isLoading && !this.error;
    }
  },

  async mounted() {
    await this.initializeComponent();
  },

  methods: {
    async initializeComponent() {
      const storedUserId = encryptUtility.localStorageDecrypt("orginalId");
      if (storedUserId) {
        this.selectedUser = storedUserId;
      }
      await this.getUserList();
    },

    async getUserList() {
      this.isLoading = true;
      this.error = null;

      try {
        const userObj = {
          pass: 1,
          imp_id: 1,
          admin_user_id: this.userId,
          imp_user_id: this.selectedUser || 0,
          comments: ""
        };

        const userData = await commonApiService.postUserImpersonation("post", userObj, false);

        if (!Array.isArray(userData)) {
          throw new Error('Invalid response format from server');
        }

        this.userList = userData.map(user => ({
          userId: String(user.user_id || ''),
          name: user.name || 'Unknown',
          email: user.email || 'No email'
        })).filter(user => user.userId && user.name);

      } catch (error) {
        this.error = error.message;
      } finally {
        this.isLoading = false;
      }
    },

    async handleImpersonation() {
      if (!this.isValid) return;

      this.isLoading = true;
      this.error = null;

      try {
        const result = await this.submitImpersonation();
        this.impId = result;
        if (result) {
          await this.updateLocalStorage();
          this.notifyAndRedirect();
        }
      } catch (error) {
        this.error = error.message;
      } finally {
        this.isLoading = false;
      }
    },

    async submitImpersonation() {
      const userObj = {
        pass: 2,
        imp_id: 1,
        admin_user_id: this.userId,
        imp_user_id: this.selectedUser,
        comments: ""
      };

      const res = await commonApiService.postUserImpersonation("post", userObj, false);
      return res?.imp_id;
    },

    async updateLocalStorage() {
      encryptUtility.localStorageEncrypt("orginalId", this.userId.toString());
      encryptUtility.localStorageEncrypt("userID", this.selectedUser.toString());
    },

    notifyAndRedirect() {
      let busObj = {
        userName: this.currentUser.name,
        userEmail: this.currentUser.email,
        userId: this.currentUser.userId,
        impId: this.impId
      }
      let Alert = {
        type: "success",
        isShow: true,
        message: `You are now impersonating ${this.currentUser.name} (${this.currentUser.email})`
      };
      this.$store.commit("ConfigModule/Alert", Alert);
      bus.$emit("impersonateName", busObj);
      this.$emit('closeImpersonationDialog');
      this.$router.push("/home");
    },

    onUserChange(userId) {
      this.selectedUser = userId;
      this.error = null;

    },

    onClickCancel() {
      this.selectedUser = null;
      this.error = null;
      this.$emit('closeImpersonationDialog');
    },

    onClickOk() {
      this.handleImpersonation();
    }
  }
}
</script>

<style scoped>
.user-imitation {
  border: 1px solid #e0e0e0;
  border-radius: 4px;
}
</style>